export const UploadUrl = process.env.REACT_APP_UPLOAD_URL;
